// NeonGameRanking.jsx
import React from 'react'
import { motion } from 'framer-motion'
import { Phone } from 'lucide-react'

// Generate Fake Data
const fakeData = Array.from({ length: 50 }, (_, i) => {
  const names = ['Luna', 'Axel', 'Nova', 'Zane', 'Orion', 'Vega', 'Kai', 'Rex']
  const surnames = ['Shadow', 'Blaze', 'Storm', 'Frost', 'Cyber', 'Neo', 'Chrome', 'Bolt']
  const name = `${names[Math.floor(Math.random() * names.length)]} ${surnames[Math.floor(Math.random() * surnames.length)]}`
  const phone = `+34 6${Math.floor(Math.random() * 100000000).toString().padStart(8, '0')}`
  const time = Math.floor(Math.random() * 3000) + 1000
  return { id: i + 1, name, phone, time }
}).sort((a, b) => a.time - b.time)

const maxTime = Math.max(...fakeData.map(p => p.time))

const NeonLeaderboardRow = ({ contestant, index, maxTime }) => {
  const percent = (1 - contestant.time / maxTime) * 100
  return (
    <motion.div
      className={`flex items-center justify-between px-5 py-3 border-b border-pink-400/20 ${
        index < 10 ? 'bg-pink-500/10' : 'bg-black/10'
      }`}
      initial={{ opacity: 0, x: -10 }}
      animate={{ opacity: 1, x: 0 }}
      transition={{ delay: index * 0.01 }}
    >
      <div className="flex items-center gap-4 w-1/2">
        <div className="text-pink-400 text-lg font-extrabold drop-shadow-glow">#{index + 1}</div>
        <div className="text-white font-mono text-sm">{contestant.name}</div>
      </div>
      <div className="w-1/2 flex flex-col items-end">
        <div className="text-xs text-white/70 flex items-center gap-1">
          <Phone size={12} />
          {contestant.phone}
        </div>
        <div className="w-full bg-gray-700 rounded-full h-2 mt-1">
          <div
            className="bg-pink-500 h-2 rounded-full transition-all"
            style={{ width: `${percent}%` }}
          />
        </div>
        <div className="text-pink-300 text-sm mt-1 font-mono">{contestant.time}ms</div>
      </div>
    </motion.div>
  )
}

export default function NeonGameRanking() {
  return (
    <div className="min-h-screen bg-gradient-to-br from-black via-[#0b0010] to-[#1a001f] text-white p-8 font-mono">
      <div className="text-center mb-10">
        <h1 className="text-5xl font-bold text-pink-500 drop-shadow-glow uppercase tracking-widest">
          🔥 VACWAY NEON RANKING 🔥
        </h1>
        <p className="text-pink-300 mt-2 text-sm uppercase tracking-wider">Fastest sales of the day</p>
      </div>

      <div className="rounded-2xl overflow-hidden border border-pink-500 shadow-[0_0_30px_#ff00cc66] max-h-[600px] overflow-y-auto">
        {fakeData.map((contestant, index) => (
          <NeonLeaderboardRow
            key={contestant.id}
            contestant={contestant}
            index={index}
            maxTime={maxTime}
          />
        ))}
      </div>
    </div>
  )
}
